var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 4.5,
    fill: "white",
    stroke: "#F8F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3872_1208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9627 9.32239C21.876 9.55283 21.8283 9.80216 21.8283 10.0625C21.8283 11.2255 22.7747 12.1719 23.9377 12.1719C24.1982 12.1719 24.4476 12.1241 24.6781 12.0373C25.5498 13.3806 26.0456 14.9103 26.1282 16.5162C26.6316 16.7431 27.1036 17.0244 27.5405 17.3586C27.5452 17.2391 27.5471 17.1195 27.5471 17C27.5471 14.8831 26.9305 12.8631 25.7594 11.1239C25.9419 10.8119 26.0471 10.4493 26.0471 10.0625C26.0471 8.89953 25.1007 7.95312 23.9377 7.95312C23.551 7.95312 23.1885 8.05827 22.8765 8.2407C21.1373 7.06981 19.1172 6.45312 17.0002 6.45312C16.8807 6.45312 16.7611 6.455 16.6416 6.45969C16.9758 6.89656 17.2571 7.36859 17.4839 7.87203C19.0898 7.95462 20.6195 8.45075 21.9627 9.32239Z",
    fill: "url(#paint0_linear_3872_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0375 24.6776C12.1242 24.4472 12.1719 24.1979 12.1719 23.9375C12.1719 22.7745 11.2255 21.8281 10.0625 21.8281C9.80216 21.8281 9.55283 21.8759 9.32239 21.9625C8.4507 20.6193 7.95458 19.0896 7.87203 17.4838C7.36859 17.2569 6.89656 16.9756 6.45969 16.6414C6.455 16.7609 6.45312 16.8805 6.45312 17C6.45312 19.1166 7.06981 21.1371 8.2407 22.8764C8.05827 23.1884 7.95312 23.5508 7.95312 23.9375C7.95312 25.1005 8.89953 26.0469 10.0625 26.0469C10.4492 26.0469 10.8117 25.9417 11.1237 25.7593C12.863 26.9302 14.8835 27.5469 17 27.5469C17.1195 27.5469 17.2391 27.545 17.3586 27.5403C17.0244 27.1034 16.7431 26.6314 16.5162 26.128C14.9104 26.0454 13.3807 25.5493 12.0375 24.6776Z",
    fill: "url(#paint1_linear_3872_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1471 22.0752C24.1471 21.5206 23.6957 21.0697 23.1412 21.0697C22.5867 21.0697 22.1357 21.5206 22.1357 22.0752C22.1357 22.6297 22.5867 23.0811 23.1412 23.0811C23.6957 23.0811 24.1471 22.6297 24.1471 22.0752Z",
    fill: "url(#paint2_linear_3872_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1419 24.4874C21.6921 24.4874 20.5127 25.6667 20.5127 27.1166V28.3766C21.3039 28.7755 22.1969 29 23.141 29C24.086 29 24.9804 28.775 25.7716 28.3756V27.1166C25.7716 26.4139 25.4979 25.7539 25.0014 25.2575C24.5046 24.7611 23.8441 24.4874 23.1419 24.4874Z",
    fill: "url(#paint3_linear_3872_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1406 17.2812C19.9095 17.2812 17.2812 19.9095 17.2812 23.1406C17.2812 24.8098 17.983 26.3178 19.1061 27.3861V27.1166C19.1061 25.5781 19.9719 24.2384 21.2413 23.5578C20.9211 23.1486 20.7298 22.6339 20.7298 22.0752C20.7298 20.7453 21.8117 19.6634 23.1416 19.6634C24.4719 19.6634 25.5538 20.7453 25.5538 22.0752C25.5538 22.633 25.363 23.1467 25.0442 23.5555C25.3897 23.7406 25.7098 23.9778 25.9953 24.2628C26.7575 25.025 27.1775 26.0384 27.1775 27.1166V27.3837C28.2997 26.3159 29 24.8084 29 23.1406C29 19.9095 26.3717 17.2812 23.1406 17.2812Z",
    fill: "url(#paint4_linear_3872_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8659 9.79392C11.8659 9.23939 11.4145 8.78845 10.86 8.78845C10.3054 8.78845 9.85449 9.23939 9.85449 9.79392C9.85449 10.3485 10.3054 10.7999 10.86 10.7999C11.4145 10.7999 11.8659 10.3485 11.8659 9.79392Z",
    fill: "url(#paint5_linear_3872_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23145 14.8353V16.0953C9.0227 16.4942 9.91566 16.7188 10.8597 16.7188C11.8047 16.7188 12.6991 16.4938 13.4904 16.0944V14.8353C13.4904 14.1327 13.2166 13.4727 12.7202 12.9763C12.2233 12.4799 11.5629 12.2061 10.8607 12.2061C9.41082 12.2061 8.23145 13.3855 8.23145 14.8353Z",
    fill: "url(#paint6_linear_3872_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82484 15.1048V14.8353C6.82484 13.2969 7.69063 11.9572 8.96 11.2766C8.63984 10.8673 8.44859 10.3527 8.44859 9.79391C8.44859 8.46406 9.53047 7.38219 10.8603 7.38219C12.1906 7.38219 13.2725 8.46406 13.2725 9.79391C13.2725 10.3517 13.0817 10.8655 12.763 11.2742C13.1084 11.4594 13.4286 11.6966 13.7141 11.9816C14.4762 12.7438 14.8962 13.7572 14.8962 14.8353V15.1025C16.0184 14.0347 16.7188 12.5272 16.7188 10.8594C16.7188 7.62828 14.0905 5 10.8594 5C7.62828 5 5 7.62828 5 10.8594C5 12.5286 5.70172 14.0366 6.82484 15.1048Z",
    fill: "url(#paint7_linear_3872_1208)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3872_1208",
    x1: 22.0943,
    y1: 6.45312,
    x2: 22.0943,
    y2: 17.3586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3872_1208",
    x1: 11.9059,
    y1: 16.6414,
    x2: 11.9059,
    y2: 27.5469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3872_1208",
    x1: 23.1414,
    y1: 21.0697,
    x2: 23.1414,
    y2: 23.0811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3872_1208",
    x1: 23.1421,
    y1: 24.4874,
    x2: 23.1421,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3872_1208",
    x1: 23.1406,
    y1: 17.2812,
    x2: 23.1406,
    y2: 27.3861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3872_1208",
    x1: 10.8602,
    y1: 8.78845,
    x2: 10.8602,
    y2: 10.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3872_1208",
    x1: 10.8609,
    y1: 12.2061,
    x2: 10.8609,
    y2: 16.7188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3872_1208",
    x1: 10.8594,
    y1: 5,
    x2: 10.8594,
    y2: 15.1048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3872_1208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchesIcon);
export default __webpack_public_path__ + "static/media/matchesIcon.6f184b19f85270489d48f67cf84e6646.svg";
export { ForwardRef as ReactComponent };